import React, { useEffect, useState } from "react";
import styled from "styled-components";
import servicedata from "./Servicedata";
import Fade from "react-reveal/Fade";
function Services({ ServiceRef }) {
  const [currenttab, setCurrenttab] = useState("one");
  const [windowSize, setWindowSize] = useState({
    width: window.innerWidth,
    height: window.innerHeight,
  });

  useEffect(() => {
    // Update window size state when the component mounts
    setWindowSize({
      width: window.innerWidth,
      height: window.innerHeight,
    });

    // Add event listener to update window size state on resize
    const handleResize = () => {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    };

    window.addEventListener("resize", handleResize);

    // Clean up the event listener on component unmount
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <Fade>
      <Container ref={ServiceRef}>
        <Title>
          <h2>Services</h2>
        </Title>

        {windowSize.width < "768" ? (
          <ServicesContainer>
            <ServicesFilter>
              <label
                className={
                  currenttab === "one"
                    ? "active service-filter"
                    : "service-filter"
                }
                onClick={() => setCurrenttab("one")}
              >
                <span></span>Photography
              </label>
              <label
                className={
                  currenttab === "five"
                    ? "active service-filter"
                    : "service-filter"
                }
                onClick={() => setCurrenttab("five")}
              >
                <span></span>Makeup & Hair Artist
              </label>
              <label
                className={
                  currenttab === "two"
                    ? "active service-filter"
                    : "service-filter"
                }
                onClick={() => setCurrenttab("two")}
              >
                <span></span>Brand Management
              </label>
            </ServicesFilter>
            <ServicesFilter>
              <label
                className={
                  currenttab === "three"
                    ? "active service-filter"
                    : "service-filter"
                }
                onClick={() => setCurrenttab("three")}
              >
                <span></span>Product Management
              </label>
              <label
                className={
                  currenttab === "four"
                    ? "active service-filter"
                    : "service-filter"
                }
                onClick={() => setCurrenttab("four")}
              >
                <span></span>Web development
              </label>
            </ServicesFilter>
          </ServicesContainer>
        ) : (
          <ServicesContainer>
            <ServicesFilter>
              <label
                className={
                  currenttab === "one"
                    ? "active service-filter"
                    : "service-filter"
                }
                onClick={() => setCurrenttab("one")}
              >
                <span></span>Photography
              </label>
              <label
                className={
                  currenttab === "five"
                    ? "active service-filter"
                    : "service-filter"
                }
                onClick={() => setCurrenttab("five")}
              >
                <span></span>Makeup & Hair Artist
              </label>
              <label
                className={
                  currenttab === "two"
                    ? "active service-filter"
                    : "service-filter"
                }
                onClick={() => setCurrenttab("two")}
              >
                <span></span>Brand Management
              </label>
              <label
                className={
                  currenttab === "three"
                    ? "active service-filter"
                    : "service-filter"
                }
                onClick={() => setCurrenttab("three")}
              >
                <span></span>Product Management
              </label>
              <label
                className={
                  currenttab === "four"
                    ? "active service-filter"
                    : "service-filter"
                }
                onClick={() => setCurrenttab("four")}
              >
                <span></span>Web development
              </label>
            </ServicesFilter>
          </ServicesContainer>
        )}

        <ServiceBox>
          <ServiceDescription>
            <Description>
              <DescriptionTitle>
                {servicedata[currenttab].title}
              </DescriptionTitle>
              <p>{servicedata[currenttab].description}</p>
            </Description>
            <DescriptionImage>
              <img src={servicedata[currenttab].image} />
            </DescriptionImage>
          </ServiceDescription>
        </ServiceBox>
      </Container>
    </Fade>
  );
}
const Container = styled.div`
  width: 100%;
  background-color: #fff;
  height: 100vh;
  min-height: 800px;

  position: relative;
  /* padding-top: 110px; */
  padding-top: 180px;
  padding-bottom: 180px;
  display: flex;
  flex-direction: column;

  margin: auto;
  justify-content: center;
  max-width: 2000px;
`;

const Title = styled.div`
  font-size: 26px;
  margin-bottom: 40px;
  align-self: center;
`;

// const Title = styled.div`
//   padding: 30px 0px;
//   h1 {
//     text-align: center;
//     color: #6b6b6b;
//   }
//`;
const ServicesContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  @media only screen and (max-width: 768px) {
    display: flex;
    flex-direction: column;
  }
`;
const ServicesFilter = styled.div`
  width: 70%;

  display: flex;
  justify-content: space-between;
  .service-filter {
    width: 200px;
    padding: 14px 0px;
    background-color: #ececec;
    text-align: center;
    border-radius: 5px;
    font-size: 14px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: background 0.3s linear;
  }

  .active {
    position: relative;
    background-color: #c9a54e;
    color: #fff;
    transition: background 0.3s linear;
  }
  .active::after {
    content: "";
    position: absolute;
    background-color: #c9a54e;
    width: 2px;
    height: 55px;
    left: 50%;
    bottom: -70px;
    transition: background 0.3s linear;
  }

  .service-filter span {
    color: #6b6b6b;
    margin-right: 3px;
  }

  @media only screen and (min-width: 1080px) and (max-width: 1260px) {
    .service-filter {
      width: 150px;
      font-size: 12px;
    }
  }

  @media only screen and (min-width: 768px) and (max-width: 1080px) {
    width: 90%;
    .service-filter {
      width: 120px;
      font-size: 12px;
      text-align: center;
    }
  }

  @media only screen and (max-width: 768px) {
    width: 85%;
    justify-content: center;
    margin-bottom: 20px;
    label {
      margin-right: 20px;
    }

    .active::after {
      display: none;
    }
    .service-filter {
      width: 80px;
      font-size: 10px;
      text-align: center;
    }
  }
`;

const ServiceBox = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  margin-top: 85px;

  @media only screen and (max-width: 768px) {
    margin-top: 20px;
  }
`;
const ServiceDescription = styled.div`
  background-color: #c9a54e;
  width: 60%;
  display: flex;
  justify-content: space-between;
  padding: 30px;
  border-radius: 5px;
  height: 400px;
  @media only screen and (max-width: 1080px) {
    width: 90%;
    height: fit-content;
    background-color: #c9a54e;
  }

  @media only screen and (max-width: 768px) {
    width: 70%;
    height: fit-content;
    flex-direction: column-reverse;
    align-items: center;
    justify-content: center;
    text-align: center;
  }
`;

const Description = styled.div`
  width: 50%;
  padding-top: 10px;
  p {
    font-size: 14px;
    font-weight: 400;
    line-height: 22px;
    font-family: "Nunito", sans-serif;
  }

  @media only screen and (max-width: 943px) {
    p {
      font-size: 11px;
      line-height: 18px;
    }
  }
  @media only screen and (max-width: 576px) {
    padding-top: 0%;
  }

  @media only screen and (max-width: 768px) {
    width: 70%;
    height: fit-content;
  }
`;
const DescriptionImage = styled.div`
  width: 40%;
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  @media only screen and (max-width: 768px) {
    width: 70%;
    height: fit-content;

    margin-top: 30px;
    margin-bottom: 30px;
  }
`;
const DescriptionTitle = styled.div`
  margin-bottom: 50px;
  font-weight: bold;
  @media only screen and (max-width: 576px) {
    margin-bottom: 10px;
  }
`;

export default Services;
